<template>
    <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Full Member Price
          </th>
          <th v-if="!excludeService" class="text-left">
            Service Member Price
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>${{ priceInfo.fullMemberPrice }}</td>
          <td v-if="!excludeService">${{ priceInfo.serviceMemberPrice }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  name: 'SimpleFeeTable',
  props: {
    priceInfo: Object,
    excludeService: Boolean
  }
})
</script>